import React, { useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import { ResizableBox } from 'react-resizable';
import Header from './Header/Header';
import WriteContent from '@web-mail-write/WritePage';
import './WriteLetterWeb.scss';
import { useActions, useAppSelector } from '@web-common/state/createStore';
import { MailActions } from '@web-common/state/reducer';
import { TemplateAddModal } from '@web-setting/Mail/components/CustomTemplate/template_add_modal';
const WriteLetterWeb = () => {
    const [translate, settranslate] = useState({ x: 0, y: 0 });
    const showWebWriteLetter = useAppSelector(state => state.mailReducer.showWebWriteLetter);
    const mailLength = useAppSelector(state => state.mailReducer.mails.length);
    const mailActions = useActions(MailActions);
    const [boxWidth, setBoxWidth] = useState(1000);
    const [boxHeight, setBoxHeight] = useState(600);
    const [maxConstraints, setMaxConstraints] = useState([300, 200]);
    const defaultX = 150;
    const defaultY = 150;
    const [preW, setPreW] = useState(boxWidth);
    const [preH, setPreH] = useState(boxHeight);
    const [execAutoSaveDraft, setExecAutoSaveDraft] = useState(false);
    useEffect(() => {
        const clientW = document.body.clientWidth;
        const clientH = document.body.clientHeight;
        setMaxConstraints([clientW - 20, clientH - 20]);
        settranslate({ x: defaultX, y: defaultY });
    }, []);
    const onResize = (e, data) => {
        const gapH = data.size.height - preH;
        const gapW = data.size.width - preW;
        setBoxWidth(data.size.width);
        setBoxHeight(data.size.height);
        let { x } = translate;
        let { y } = translate;
        if (['w', 'nw', 'sw'].includes(data.handle)) {
            x = translate.x - gapW;
        }
        if (['n', 'nw', 'ne'].includes(data.handle)) {
            y = translate.y - gapH;
        }
        settranslate({ x, y });
        setPreH(data.size.height);
        setPreW(data.size.width);
    };
    const handleDrag = (e, data) => {
        settranslate({
            x: data.x,
            y: data.y,
        });
    };
    const showWrapStyle = {
        width: '100vw',
        height: '100vh',
        top: 0,
        left: 0,
    };
    const hideWrapStyle = {
        width: '0',
        height: '0',
        top: 'calc(100vh - 65px)',
        left: 'calc(100vw - 44px)',
    };
    const clickWrap = e => {
        e.persist();
        if (e.target.className === 'write-mail-wrap draggable-animate') {
            mailActions.doShowWebWrite(false);
        }
    };
    useEffect(() => {
        if (!showWebWriteLetter || mailLength < 1) {
            setExecAutoSaveDraft(false);
        }
        else {
            setExecAutoSaveDraft(true);
        }
    }, [showWebWriteLetter, mailLength]);
    useEffect(() => () => {
        setExecAutoSaveDraft(false);
    }, []);
    return (React.createElement("div", { className: "write-mail-wrap draggable-animate", onClick: e => {
            clickWrap(e);
        }, hidden: mailLength === 0, style: showWebWriteLetter ? showWrapStyle : hideWrapStyle },
        React.createElement(Draggable, { handle: ".handle", bounds: "parent", defaultClassName: "draggable", onDrag: (e, data) => {
                handleDrag(e, data);
            }, position: { x: translate.x, y: translate.y } },
            React.createElement(ResizableBox, { width: boxWidth, height: boxHeight, minConstraints: [740, 640], maxConstraints: maxConstraints, className: "write-letter-resize", handle: h => React.createElement("span", { className: `custom-component-${h}` }), onResize: (e, data) => {
                    onResize(e, data);
                }, resizeHandles: ['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne'] },
                React.createElement("div", { className: "container" },
                    React.createElement(Header, null),
                    React.createElement("div", { className: "write" },
                        React.createElement(WriteContent, { execAutoSaveDraft: execAutoSaveDraft, cond: "innerWeb" }),
                        React.createElement(TemplateAddModal, null)))))));
};
export default WriteLetterWeb;
